// extracted by mini-css-extract-plugin
module.exports = {"shield":"style_shield__H0a3E","is-single":"style_is-single__FNWbR"};